exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nwTkh{background:#111;color:#878787}._3FLa4{margin:0 auto;padding:20px 8px;max-width:1000px;text-align:center;font-size:15.2px;font-size:.95rem;font-weight:300}", ""]);

// exports
exports.locals = {
	"root": "nwTkh",
	"container": "_3FLa4"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/components/Copyright/Copyright.css
// module id = 649
// module chunks = 0 1 2 3 4 5